const useMode = () => {
  const isProd = process.env.NODE_ENV === 'production';
  const isDev = process.env.NODE_ENV === 'development';

  return {
    isProd,
    isDev,
  };
};

export default useMode;
